import React from 'react';

import type { ShellProps } from '../Shell/Shell';
import type { ShellContentProps } from '../Shell/ShellContent';
import type { ShellFooterProps } from '../Shell/ShellFooter';
import type { ShellHeaderProps } from '../Shell/ShellHeader';
import { colors, darkThemeSelector, styled } from '../../stitches.config';
import { Shell } from '../Shell/Shell';
import { ShellContent } from '../Shell/ShellContent';
import { ShellFooter } from '../Shell/ShellFooter';
import { ShellHeader } from '../Shell/ShellHeader';

const SkimmerHeaderContainer = styled(ShellHeader);
SkimmerHeaderContainer.displayName = 'SkimmerHeaderContainer';

export function SkimmerHeader(props: ShellHeaderProps) {
  return <SkimmerHeaderContainer type="drawer" {...props} />;
}

const SkimmerContentContainer = styled(ShellContent);
SkimmerContentContainer.displayName = 'SkimmerContentContainer';

export function SkimmerContent(props: ShellContentProps) {
  return <SkimmerContentContainer {...props} />;
}

const SkimmerFooterContainer = styled(ShellFooter);
SkimmerFooterContainer.displayName = 'SkimmerFooterContainer';

export function SkimmerFooter(props: ShellFooterProps) {
  return <SkimmerFooterContainer {...props} />;
}

const SkimmerContainer = styled(Shell, {
  gridArea: 'skimmer',

  '&:not(:last-child)': {
    strokeRight: colors.strokeNeutralLight,
  },

  [darkThemeSelector]: {
    '&:not(:last-child)': {
      strokeRight: colors.strokeNeutralDark,
    },
  },

  '@mobile': {
    width: '100%',
    minHeight: '$160',
    maxHeight: '$360',
  },

  '@notMobile': {
    width: '$360',
  },
});
SkimmerContainer.displayName = 'SkimmerContainer';

export type SkimmerProps = ShellProps & {
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement | null>;
};

export function Skimmer({ children, ref, ...props }: SkimmerProps) {
  return (
    <SkimmerContainer ref={ref} {...props}>
      {children}
    </SkimmerContainer>
  );
}
